<script setup>
defineProps({
  type: { type: String, default: '', requird: false }
})
const { data: searchPointList } = await useFetch('/api/search/list')
const { result, keyword } = useLivecamSearch(searchPointList.value)
</script>

<template>
  <div
    class="livecamSearch"
    :data-type="type"
  >
    <div class="content">
      <input
        v-model="keyword"
        type="search"
        placeholder="ライブカメラを検索（住所、地名など）"
        @keydown.enter.prevent
      >
    </div>
    <LivecamSearchPointCandidate
      v-show="keyword !== ''"
      :result="result"
    />
  </div>
</template>

<style lang="scss" scoped>
.livecamSearch {
  position: relative;
  input {
    display: none;
    &:is([data-type="full"] *) {
      display: block;
      width: 100%;
      font-size: 15px;
      font-weight: 600;
      line-height: 1em;
      outline: none;
    }
  }
  .content {
    &:is([data-type="full"] *) {
      display: flex;
      padding: 5px 6px 5px 10px;
      align-items: center;
      gap: 10px;
      align-self: stretch;
      border-radius: 56px;
      border: 1px solid #CCC;
      background-color: #FFF;
    }
  }
}
@media screen and (min-width: 830px) {
  .livecamSearch {
    input {
      display: block;
      min-width: 275px;
      font-size: 15px;
      font-weight: 600;
      line-height: 1em;
      outline: none;
    }
    .content {
      display: flex;
      padding: 5px 6px 5px 10px;
      align-items: center;
      gap: 10px;
      align-self: stretch;
      border-radius: 56px;
      border: 1px solid #CCC;
      background-color: #FFF;
    }
    .candidate {
      display: block;
      position: absolute;
      top: calc(100% + 1px);
      left: 0;
      width: 100%;
      max-height: 450px;
      background-color: #fff;
      border-radius: 6px;
      box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.25);
      z-index: 1;
      overflow-y: scroll;
      border-top: solid 1px #D8E0DF;
      scrollbar-width: thin;
      scrollbar-color: #438fec transparent;
      .link {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 8px 20px 8px 10px;
        cursor: pointer;
        border-bottom: solid 1px #D8E0DF;
        &::after {
          position: absolute;
          top: 50%;
          right: 10px;
          width: 8px;
          height: 8px;
          border-top: solid 2px #303030;
          border-right: solid 2px #303030;
          transform: translateY(-50%) rotate(45deg);
          content: "";
        }
      }
      .name {
        color: #3569c0;
        font-weight: 600;
        line-height: 17px;
      }
      .result {
        padding: 5px 20px 5px 10px;
      }
    }
  }
}
</style>
